import FieldLabel from './FieldLabel';
export { FieldLabel };
export default FieldLabel;
